<script setup lang="ts">
// Shows the API's sentence verbatim (it names the offending value); the stable code is shown beside it.
import { computed } from 'vue';
import { ApiProblem } from '../api/client';

const props = defineProps<{ error: unknown; context?: string }>();
const p = computed(() => (props.error instanceof ApiProblem ? props.error : undefined));
const text = computed(() => p.value?.detail ?? (props.error instanceof Error ? props.error.message : String(props.error)));
</script>

<template>
  <div v-if="error" class="alert" role="alert">
    <strong v-if="context">{{ context }}: </strong>
    <span data-testid="problem-detail">{{ text }}</span>
    <span v-if="p" class="code">{{ p.code }}<template v-if="p.reason"> / {{ p.reason }}</template> (HTTP {{ p.status }})</span>
  </div>
</template>
